import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ACCEPTED from "../../../assets/Accepted.svg";
import PAID from "../../../assets/Paid.svg";

class AcceptanceStatusBand extends Component {
  state = {};

  render() {
    const { stage } = this.props;
    let bandStatus = null;
    if (this.props.isSharedDocument) {
      if (this.props.paymentStatus === "Paid") {
        bandStatus = (
          <div className="doc-status-band remove-from-export">
            <img src={PAID} className="doc-imgband-check-wrapper" alt="Revv" />
            <div>You have made payment in this document</div>
          </div>
        );
      } else if (
        this.props.recipientType === "ACCEPTOR" &&
        stage === "COMPLETED"
      ) {
        bandStatus = (
          <div className="doc-status-band remove-from-export">
            <img
              src={ACCEPTED}
              className="doc-imgband-check-wrapper"
              alt="Revv"
            />
            <div>Everyone accepted the document</div>
          </div>
        );
      } else if (
        this.props.recipientType === "ACCEPTOR" &&
        stage === "DECLINED"
      ) {
        bandStatus = (
          <div className="doc-declined-status-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>
            <div>Document was rejected</div>
          </div>
        );
      } else if (
        this.props.acceptingStates === "REJECTED" ||
        this.state.docAcceptingState === "REJECTED"
      ) {
        bandStatus = (
          <div className="doc-declined-status-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>
            Document was rejected
          </div>
        );
      } else if (
        this.props.acceptingStates === "ACCEPTED" ||
        this.state.docAcceptingState === "ACCEPTED"
      ) {
        bandStatus = (
          <div className="doc-status-band remove-from-export">
            <span className="doc-statusband-check-accepted">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>
            <div>You have accepted this document</div>
          </div>
        );
      } else if (
        this.props.recipientType === "ACCEPTOR" &&
        this.props.acceptingStates === ""
      ) {
        bandStatus = (
          <div className="doc-status-warning-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>
            <div>Your consent is required on this document</div>
          </div>
        );
      } else if (
        this.props.recipientType === "FILLER" &&
        stage === "SENT_FOR_FILLING"
      ) {
        bandStatus = (
          <div className="doc-status-warning-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>

            <div>Please complete filling this document before signing</div>
          </div>
        );
      } else if (
        (this.props.recipientType === "FILLER" ||
          this.props.recipientType === "SIGNER") &&
        (stage === "SENT" || stage === "SENT_FOR_FILLING")
      ) {
        bandStatus = (
          <div className="doc-status-warning-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>

            <div>
              You have filled this document. Check email for link to eSign the
              document.
            </div>
          </div>
        );
      } else if (
        (this.props.recipientType === "FILLER" ||
          this.props.recipientType === "SIGNER") &&
        stage === "DECLINED"
      ) {
        bandStatus = (
          <div className="doc-declined-status-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>
            <div>Document has been declined.</div>
          </div>
        );
      }
    }

    return bandStatus;
  }
}

export default AcceptanceStatusBand;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/StatusBands/AcceptanceStatusBand.js